module.exports = __webpack_public_path__ + "media/icons/available-benefits-bee66790.svg";